/* eslint-disable no-shadow */
import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import * as Sentry from "@sentry/react";
import SyncIcon from "@mui/icons-material/Sync";
import moment from "moment";
import { Box } from "@mui/material";
import { css, StyleSheet } from "aphrodite";
import Typography from "../../../components/common/new/Typography/Typography";
import Dashboard from "../../../services/api/dashboard";
// import { selectAllSIUsers } from "../../../redux/selectors/user";
import Info from "../../../assets/svg/Info";
import GroupIcon from "../../../assets/svg/GroupIcon";
import MyZone from "../../../assets/images/My_Zone.png";
import BsgIndia from "../../../assets/images/BSG_India.png";

function HappinessCounter() {
  const [counterValue, setCounterValue] = useState([]);
  // const { isAreaSi, isHelpDesk, isHelpDeskAdmin, isNationalLeader } =
  //   useSelector(selectAllSIUsers);

  // const showMyZoneCounter = !(
  //   isAreaSi ||
  //   isHelpDesk ||
  //   isHelpDeskAdmin ||
  //   isNationalLeader
  // );

  const allowedRoles = [
    "Area",
    "Cluster",
    "Zone",
    "Region",
    "Chapter",
    "District",
  ];
  const positionRole = localStorage.getItem("positionRole");

  const zoneCounter = counterValue.myZone;
  const zoneValue = zoneCounter?.toString().split("");

  const YDCounter = counterValue.youthDivision;
  const YDvalue = YDCounter?.toString().split("");

  const BSGCounter = counterValue.bsg;
  const BSGValue = BSGCounter?.toString().split("");

  const happinessCounter = async () => {
    try {
      const response = await Dashboard.getHappinessReport();
      setCounterValue(response.data);
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  useEffect(() => {
    happinessCounter();
  }, []);

  // ✅ Kal card badhana ho to sirf yahan object add karo, baki sab automatic
  const cards = [
    {
      key: "bsg",
      title: "BSG",
      digits: BSGValue,
      color: "#41B0C3",
      image: BsgIndia,
      IconComponent: null,
      visible: true,
    },
    {
      key: "youthDivision",
      title: "Youth Division",
      digits: YDvalue,
      color: "#499DFE",
      image: null,
      IconComponent: GroupIcon,
      visible: true,
    },
    {
      key: "myZone",
      title: `My ${positionRole}`,
      digits: zoneValue,
      color: "#2556A3",
      image: MyZone,
      IconComponent: null,
      visible: allowedRoles.includes(positionRole), // ✅ condition yahan, hardcode nahi
    },
  ];

  // ✅ Sirf visible cards — count automatic derive hoga
  const visibleCards = cards.filter((card) => card.visible);

  const happinessStyles = StyleSheet.create({
    headerContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "2px",
      padding: "10px",
      background: "linear-gradient(135deg, #0b2c8a 0%, #f5576c 100%)",
      borderRadius: "16px",
      color: "white",
      boxShadow: "0 8px 32px rgba(240, 147, 251, 0.3)",
    },
    syncButton: {
      background: "rgba(255, 255, 255, 0.2)",
      border: "none",
      borderRadius: "12px",
      padding: "8px 12px",
      color: "white",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      fontSize: "12px",
      backdropFilter: "blur(10px)",
      transition: "all 0.3s ease",
      ":hover": {
        background: "rgba(255, 255, 255, 0.3)",
        transform: "translateY(-2px)",
      },
    },
    countersContainer: {
      display: "grid",
      // ✅ visibleCards.length se dynamic — hardcode nahi, future-safe hai
      gridTemplateColumns: `repeat(${visibleCards.length}, 1fr)`,
      gap: "6px",
      "@media (max-width: 768px)": {
        gridTemplateColumns: "1fr",
        gap: "16px",
      },
    },
    counterCard: {
      background: "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
      borderRadius: "20px",
      padding: "5px",
      paddingLeft: "12px",
      textAlign: "left",
      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
      border: "1px solid rgba(255, 255, 255, 0.2)",
      transition: "all 0.3s ease",
      display: "flex",
      flexDirection: "column",
      ":hover": {
        transform: "translateY(-5px) scale(1.02)",
        boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
      },
    },
    counterTitle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      marginBottom: "2px",
      color: "#333",
    },
    digitContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "1px",
      flexWrap: "wrap",
    },
    digitBox: {
      background: "linear-gradient(145deg, #f8fafc 0%, #e2e8f0 100%)",
      borderRadius: "9px",
      width: "30px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "16px",
      fontWeight: "bold",
      boxShadow: "inset 0 2px 4px rgba(0, 0, 0, 0.1)",
      border: "2px solid rgba(255, 255, 255, 0.8)",
      "@media (max-width: 768px)": {
        width: "34px",
        height: "42px",
        fontSize: "24px",
      },
    },
    iconSmall: {
      fontSize: "22px",
      width: "22px",
      height: "auto",
    },
    iconMedium: {
      width: "28px",
      height: "28px",
    },
  });

  const renderCounterCard = ({
    key,
    title,
    digits,
    color,
    image,
    IconComponent,
  }) => (
    <Box key={key} className={css(happinessStyles.counterCard)}>
      <Box className={css(happinessStyles.counterTitle)}>
        {image ? (
          <img
            src={image}
            alt={title}
            style={{ width: 28, height: 28, flexShrink: 0 }}
          />
        ) : (
          IconComponent && (
            <IconComponent className={css(happinessStyles.iconSmall)} />
          )
        )}
        <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#333" }}>
          {title}
        </Typography>
        <Info />
      </Box>

      <Box className={css(happinessStyles.digitContainer)}>
        {digits?.map((digit, index) => (
          <Box
            // eslint-disable-next-line react/no-array-index-key
            key={`${digit}-${index}`}
            className={css(happinessStyles.digitBox)}
            style={{ color }}
          >
            {digit}
          </Box>
        ))}
      </Box>
    </Box>
  );

  return (
    <Box>
      {/* Header */}
      <Box className={css(happinessStyles.headerContainer)}>
        <Typography size="20px" weight={700} color="white">
          Happiness Counter
        </Typography>
        <button
          type="button"
          className={css(happinessStyles.syncButton)}
          onClick={happinessCounter}
        >
          <SyncIcon style={{ fontSize: "16px" }} />
          Last Sync:{" "}
          {moment(counterValue.lastSyncBDS).format("D MMM, YYYY") || "-"}
          <span style={{ marginLeft: "4px" }}>
            {moment(counterValue.lastSyncBDS).format("h:mm A") || "-"}
          </span>
        </button>
      </Box>

      {/* Counters */}
      <Box className={css(happinessStyles.countersContainer)}>
        {visibleCards.map((card) => renderCounterCard(card))}
      </Box>
    </Box>
  );
}

export default HappinessCounter;
